import { createFileRoute } from "@tanstack/react-router";

import { SKUStoreMappingPage } from "@/features/SKUStore/SKUStoreMappingPage";

export const Route = createFileRoute("/_auth/sku-store/$siteId/$skuId/mapping")(
  {
    component: SKUStoreMappingPage,
  },
);
